import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8001/api/v1';

const PublicTermsPage: React.FC = () => {
  const [html, setHtml] = useState<string | null>(null);

  useEffect(() => {
    fetch(`${API_BASE}/legal/terms.html`)
      .then(r => r.text())
      .then(setHtml)
      .catch(() => setHtml('<p style="padding:40px;font-family:sans-serif">Unable to load Terms of Use.</p>'));
  }, []);

  if (html === null) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress />
        <Typography sx={{ ml: 2, color: '#555' }}>Loading...</Typography>
      </Box>
    );
  }

  return (
    <iframe
      srcDoc={html}
      title="Terms of Use"
      style={{ width: '100%', height: '100vh', border: 'none', display: 'block' }}
    />
  );
};

export default PublicTermsPage;
